module.exports = __webpack_public_path__ + "static/media/profile-grid.11216f6f.svg";